import { render, staticRenderFns } from "./ViForgotPassword.vue?vue&type=template&id=782e0296&scoped=true"
import script from "./ViForgotPassword.vue?vue&type=script&lang=js"
export * from "./ViForgotPassword.vue?vue&type=script&lang=js"
import style0 from "./ViForgotPassword.vue?vue&type=style&index=0&id=782e0296&prod&lang=css&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "782e0296",
  null
  
)

export default component.exports